import { Path } from '@/main/router/routerPath';

import Edit from './Edit.vue';
import List from './List.vue';
import { NAME, CRUMB_LABEL_KEY } from './constants';
import { PRReturnPolozky } from './polozky';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY),
	PRReturnPolozky.router,
]);
